<div class="bg-col-w">
    <div class="wrap p-t-4 p-b-4">
        <ng-content></ng-content>
    </div>
</div>